import { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext(null);

const STR = {
  nav_home: { zh: "首页", en: "Home" },
  nav_about: { zh: "放空简介", en: "About" },
  nav_markets: { zh: "最新市集", en: "Markets" },
  nav_workshops: { zh: "工作坊", en: "Workshops" },
  nav_vendors: { zh: "市集摊主", en: "Vendors" },
  nav_artisans: { zh: "手作达人", en: "Artisans" },
  nav_apply: { zh: "放空申请", en: "Apply" },
  nav_member: { zh: "会员", en: "Member" },
  nav_dashboard: { zh: "摊主后台", en: "Vendor" },
  nav_admin: { zh: "管理后台", en: "Admin" },
  join_market: { zh: "摊位注册", en: "Join Market" },
  login: { zh: "登录", en: "Login" },
  logout: { zh: "登出", en: "Logout" },
  register: { zh: "注册", en: "Sign Up" },

  hero_tag: { zh: "长期市集 · 不同系列", en: "A LONG-RUNNING MARKET · MANY SERIES" },
  hero_title: { zh: "放空生活集", en: "Fangkong Life Market" },
  hero_sub: {
    zh: "在城市里找一个角落，放慢脚步，和手作、音乐、好味道相遇。",
    en: "Find a corner in the city to slow down — meet makers, music and good taste.",
  },
  explore_markets: { zh: "探索市集", en: "Explore Markets" },
  become_vendor: { zh: "成为摊主", en: "Become a Vendor" },

  read_more: { zh: "了解更多", en: "Read more" },
  view_detail: { zh: "查看详情", en: "View details" },
  apply_join: { zh: "申请参与", en: "Apply to join" },
  share: { zh: "分享", en: "Share" },
  download_proposal: { zh: "下载计划书", en: "Download proposal" },
  sign_up: { zh: "立即报名", en: "Sign up now" },
  contact: { zh: "联络", en: "Contact" },
  whatsapp_us: { zh: "WhatsApp 联络", en: "Contact on WhatsApp" },
  upcoming: { zh: "即将举行", en: "Upcoming" },
  past: { zh: "已结束", en: "Past" },
  all: { zh: "全部", en: "All" },

  about_title: { zh: "放空简介", en: "About Fangkong" },
  about_intro: {
    zh: "放空生活集是一个长期举办的生活市集，以不同主题与系列，串联在地创作者、独立品牌与热爱生活的你。",
    en: "Fangkong Life Market is a long-running lifestyle market that connects local creators, indie brands and people who love life — through different themes and series.",
  },
  series_label: { zh: "系列", en: "Series" },

  markets_title: { zh: "最新市集", en: "Latest Markets" },
  workshops_title: { zh: "工作坊", en: "Workshops" },
  vendors_title: { zh: "市集摊主", en: "Market Vendors" },
  apply_title: { zh: "放空申请", en: "Join Fangkong" },
  vendor_application: { zh: "摊主申请", en: "Vendor Application" },
  artisan_application: { zh: "手作达人申请", en: "Artisan Application" },
  artisans_title: { zh: "手作达人", en: "Artisans" },
  partners_title: { zh: "联合合作单位", en: "Partners & Collaborators" },
  select_market: { zh: "选择市集", en: "Select a market" },

  name: { zh: "姓名", en: "Name" },
  phone: { zh: "电话", en: "Phone" },
  email: { zh: "邮箱", en: "Email" },
  submit: { zh: "提交", en: "Submit" },
  cancel: { zh: "取消", en: "Cancel" },
  save: { zh: "保存", en: "Save" },

  member_title: { zh: "会员中心", en: "Member Center" },
  my_coupons: { zh: "我的优惠券", en: "My Coupons" },
  coupons: { zh: "优惠券", en: "Coupons" },
  gifts: { zh: "礼品兑换", en: "Gift Redemption" },
  my_activity: { zh: "活动参与", en: "My Activity" },
  redeemed_history: { zh: "兑换记录", en: "Redeemed" },
  points: { zh: "积分", en: "Points" },
  claim: { zh: "领取", en: "Claim" },
  claimed: { zh: "已领取", en: "Claimed" },
  redeem: { zh: "兑换", en: "Redeem" },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("fk_lang") || "zh");

  const toggle = useCallback(() => {
    setLang((prev) => {
      const next = prev === "zh" ? "en" : "zh";
      localStorage.setItem("fk_lang", next);
      return next;
    });
  }, []);

  const t = useCallback((key) => (STR[key] ? STR[key][lang] : key), [lang]);
  const L = useCallback((zhVal, enVal) => (lang === "zh" ? zhVal || enVal : enVal || zhVal), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, toggle, t, L }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
